export default __webpack_public_path__ + "static/media/contact.7944e627.webp";